<template>
  <section id="infoCalls">
    <!-- MODAL DE RANGO DE FECHA -->
    <RangeDateDialog
      v-if="active"
      :active="active"
      :actualRol="CurrentRole"
      module="cdr"
      @dialog:change="eventdialog"
    ></RangeDateDialog>

    <v-card class="shadow-1 mt-5">
      <v-tabs v-model="tab" dark background-color="secondary lighten-1" hide-slider grow>
        <v-tab v-for="(item, index) in filteredTabHeaders" :key="index" @click="getCallsInfo(index)">
          <v-slide-x-transition>
            <v-icon left v-if="tab === index">mdi-check-circle-outline</v-icon>
          </v-slide-x-transition>
          {{ item }}
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item v-for="item in filteredTabHeaders" :key="item">
          <v-card flat>
            <v-container class="px-md-7" fluid v-if="customSearchInfo">
              <v-row dense justify="space-between">
                <v-col cols="12" md="auto">
                  <span class="blue-grey--text text--darken-3">
                    <span class="caption grey--text">Tipo</span>
                    {{
                      customSearchInfo.call == null ? "Todas" : customSearchInfo.call === 1 ? "Salientes" : "Entrantes"
                    }}
                  </span>
                </v-col>

                <v-col cols="12" md="auto">
                  <span class="blue-grey--text text--darken-3">
                    <span class="caption grey--text">Desde</span>
                    {{ customSearchInfo.start }}
                  </span>
                  <span class="blue-grey--text text--darken-3">
                    <span class="caption grey--text">Hasta</span>
                    {{ customSearchInfo.end }}
                  </span>
                </v-col>
              </v-row>
            </v-container>

            <v-divider v-if="customSearchInfo"></v-divider>

            <!-- Tabla -->
            <v-container fluid>
              <v-skeleton-loader v-if="isLoading" type="table"> </v-skeleton-loader>

              <v-row v-else dense justify="end">
                <v-col cols="12" md="auto">
                  <v-text-field
                    filled
                    rounded
                    dense
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Buscar"
                    single-line
                    hide-details
                    @click="
                      active = true;
                      tab = 1;
                    "
                  ></v-text-field>
                </v-col>
                <v-col cols="12" v-if="search === ''">
                  <vuescroll
                    :ops="{
                      bar: {
                        background: '#bacfcec0',
                        keepShow: true,
                      },
                    }"
                  >
                    <!-- <v-data-table
                                            :headers="headers"
                                            :items="CDRInfo"
                                            class="elevation-0"
                                            :items-per-page="50"
                                            :search="search"
                                            hide-default-footer
                                            :page.sync="currentPage"
                                            :server-items-length="totalPages"
                                            :options.sync="options"
                                        > -->
                    <v-data-table
                      :headers="headers"
                      :items="CDRInfo"
                      class="elevation-0"
                      :items-per-page="50"
                      :search="search"
                      disable-pagination
                      hide-default-footer
                    >
                      <template v-slot:[`item.actions`]="{ item }">
                        <v-menu v-if="item.recordingfile && recordingPathGenerator(item.recordingfile)" top close-on-click>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn small text icon v-bind="attrs" v-on="on" color="blue-grey">
                              <v-icon>mdi-download</v-icon>
                            </v-btn>
                          </template>

                          <v-list>
                            <v-list-item @click="descargarAudio(item.recordingfile)">
                              <v-list-item-title>WAV</v-list-item-title>
                            </v-list-item>
                            <v-list-item @click="descargarAudio(item.recordingfile, true)">
                              <v-list-item-title>MP3</v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </template>

                      <template
                        v-slot:[`item.hour`]="{
                          item,
                        }"
                      >
                        {{ item.fecha }}
                      </template>

                      <template
                        v-slot:[`item.duracion`]="{
                          item,
                        }"
                      >
                        <span>
                          {{ item.duracion | secondsToTimeFormat }}
                        </span>
                      </template>

                      <template
                        v-slot:[`item.hablado`]="{
                          item,
                        }"
                      >
                        <span>
                          {{ item.hablado | secondsToTimeFormat }}
                        </span>
                      </template>

                      <template
                        v-slot:[`item.estado`]="{
                          item,
                        }"
                      >
                        <v-chip color="transparent" small>
                          <v-icon left small :color="getSpanishState(item.estado).color"
                            >{{ getSpanishState(item.estado).icon }}
                          </v-icon>
                          {{ getSpanishState(item.estado).text }}
                        </v-chip>
                      </template>

                      <template
                        v-slot:[`item.recordingfile`]="{
                          item,
                        }"
                      >
                        <div
                          class="pt-2 pb-1"
                          :key="item.recordingfile"
                          v-if="item.recordingfile && recordingPathGenerator(item.recordingfile)"
                        >
                          <v-icon>mdi-pLay</v-icon>
                          <v-tooltip top>
                            <template
                              v-slot:activator="{
                                on,
                                attrs,
                              }"
                            >
                              <audio controls preload="none" v-on="on" v-bind="attrs" controlslist="nodownload">
                                <source
                                  :src="'https://' + webURL + recordingPathGenerator(item.recordingfile)"
                                  type="audio/wav"
                                />

                                <source
                                  :src="'https://' + webURL + recordingPathGenerator(item.recordingfile, true)"
                                  type="audio/mpeg"
                                />
                                <p>
                                  Tu navegador no implementa el elemento audio.
                                </p>
                              </audio>
                            </template>
                            <span>{{ recordingPathGenerator(item.recordingfile) }}</span>
                          </v-tooltip>
                        </div>

                        <span class="caption grey--text" v-else>No disponible</span>
                      </template>
                    </v-data-table>
                  </vuescroll>
                </v-col>

                <v-col cols="12" v-else>
                  <span></span>
                  <vuescroll
                    :ops="{
                      bar: {
                        background: '#bacfcec0',
                        keepShow: true,
                      },
                    }"
                  >
                    <v-data-table
                      :headers="headers"
                      :items="CDRInfo"
                      class="elevation-0"
                      :items-per-page="50"
                      :search="search"
                      hide-default-footer
                    >
                      <template v-slot:[`item.actions`]="{ item }">
                        <v-menu
                          v-if="item.recordingfile && recordingPathGenerator(item.recordingfile)"
                          top
                          close-on-click
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn small text icon v-bind="attrs" v-on="on" color="blue-grey">
                              <v-icon>mdi-download</v-icon>
                            </v-btn>
                          </template>

                          <v-list>
                            <v-list-item @click="descargarAudio(item.recordingfile)">
                              <v-list-item-title>WAV</v-list-item-title>
                            </v-list-item>
                            <v-list-item @click="descargarAudio(item.recordingfile, true)">
                              <v-list-item-title>MP3</v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </template>

                      <template
                        v-slot:[`item.hour`]="{
                          item,
                        }"
                      >
                        <span>{{ item.fecha }}</span>
                      </template>

                      <template
                        v-slot:[`item.duracion`]="{
                          item,
                        }"
                      >
                        <span>
                          {{ item.duracion | secondsToTimeFormat }}
                        </span>
                      </template>

                      <template
                        v-slot:[`item.hablado`]="{
                          item,
                        }"
                      >
                        <span>
                          {{ item.hablado | secondsToTimeFormat }}
                        </span>
                      </template>

                      <template
                        v-slot:[`item.dst`]="{
                          item,
                        }"
                      >
                        <span>
                          {{ item.dst || "" }}
                        </span>
                      </template>

                      <template
                        v-slot:[`item.estado`]="{
                          item,
                        }"
                      >
                        <v-tooltip top>
                          <template
                            v-slot:activator="{
                              on,
                              attrs,
                            }"
                          >
                            <v-chip color="transparent" small v-bind="attrs" v-on="on">
                              <v-icon left small :color="getSpanishState(item.estado).color"
                                >{{ getSpanishState(item.estado).icon }}
                              </v-icon>
                              {{ getSpanishState(item.estado).text }}
                            </v-chip>
                          </template>
                          <span>{{ "Top tooltip" }}</span>
                        </v-tooltip>
                      </template>

                      <template
                        v-slot:[`item.recordingfile`]="{
                          item,
                        }"
                      >
                        <div
                          :key="item.recordingfile"
                          class="pt-2 pb-1"
                          v-if="item.recordingfile && recordingPathGenerator(item.recordingfile)"
                        >
                          <v-icon>mdi-pLay</v-icon>
                          <v-tooltip bottom>
                            <template
                              v-slot:activator="{
                                on,
                                attrs,
                              }"
                            >
                              <audio controls preload="none" v-on="on" v-bind="attrs" controlslist="nodownload">
                                <source
                                  :src="'https://' + webURL + recordingPathGenerator(item.recordingfile)"
                                  type="audio/wav"
                                />

                                <source
                                  :src="'https://' + webURL + recordingPathGenerator(item.recordingfile, true)"
                                  type="audio/mpeg"
                                />
                                <p>
                                  Tu navegador no implementa el elemento audio.
                                </p>
                              </audio>
                            </template>
                            <span>{{ item.recordingfile }}</span>
                          </v-tooltip>
                        </div>

                        <span class="caption grey--text" v-else>No disponible</span>
                      </template>
                    </v-data-table>
                  </vuescroll>
                </v-col>

                <v-col cols="auto">
                  <v-pagination
                    circle
                    :total-visible="7"
                    color="primary"
                    v-model="currentPage"
                    :length="totalPages"
                    @input="handlePageChange"
                  ></v-pagination>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </section>
</template>

<script>
import vuescroll from "vuescroll";
import axios from "axios";

import RangeDateDialog from "../../components/DatePickers/DateRangePicker.vue";
import recordingPathGenerator from "@/components/Utils/recordingPathGenerator.js";
// import moment from "moment";
// import CdrDownloadToCsv from "@/components/Utils/CdrDownloadCsv";

export default {
  name: "CDR",

  inject: ["theme"],

  components: {
    RangeDateDialog,
    vuescroll,
  },

  data() {
    return {
      recordingPathGenerator,
      currentPage: 1,
      totalPages: 1,
      options: {},
      isLoading: false,
      customSearchInfo: null,
      search: "",
      active: false,
      customRequest: {},
      request: "day",
      render: false,
      webURL: null,
      tab: null,
      tabHeaders: ["Hoy", "Personalizado"],
      headers: [
        {
          text: "Fecha y Hora",
          value: "fecha",
          width: "32%",
          align: "center",
        },
        { text: "Origen", value: "src", width: "5%" },
        {
          text: "Destino",
          value: "dst",
          width: "10%",
        },
        {
          text: "Duración",
          value: "duracion",
          width: "15%",
          align: "center",
        },
        {
          text: "Hablado",
          value: "hablado",
          width: "10%",
          align: "center",
        },
        {
          text: "Estado",
          value: "estado",
          width: "7%",
        },
        {
          text: "Grabación",
          align: "center",
          value: "recordingfile",
          width: "20%",
        },
        {
          text: "Acciones",
          align: "center",
          value: "actions",
          width: "15%",
        },
      ],
      // Table Data
      CDRInfo: null,
    };
  },

  computed: {
    isDark() {
      return this.$vuetify.theme.dark;
    },

    CurrentRole() {
      return this.$store.getters["passport/GET_ROLE"];
    },

    filteredTabHeaders() {
      // if (this.CurrentRole === 10) return ["Dia", "Personalizado"];
      if (this.CurrentRole === 10) return ["Personalizado"];
      return this.tabHeaders;
    },
  },

  watch: {
    isDark() {
      this.changeThemeChart();
    },

    CurrentRole(newRole) {
      if (parseInt(newRole) === 10) {
        this.active = true;
        this.getQueues();
      } else {
        this.search("Dia");
      }
    },

    tab(val) {
      switch (val) {
        case 0:
          this.request = "day";
          this.customSearchInfo = null;
          this.currentPage = 1;
          break;

        case 1:
          this.request = "custom";
          break;

        default:
          this.request = "day";
          break;
      }
    },
  },

  created() {
    this.isLoading = true;
    if (this.CurrentRole === 10) {
      this.getCallsInfo(1);
    } else {
      this.getCallsInfo(0);
    }
  },

  // updated() {
  //     this.changeThemeChart();
  // },

  methods: {
    /**
     * [Paginador]
     * @param {string} value [Número de página a cambiar]
     */
    handlePageChange(value) {
      // console.log("aqui esta verga no sirve<", value);
      this.currentPage = value;
      this.getCallsInfo();
    },

    /**
     * [Colocador de parámetros]
     * @param {string} tab [Nombre de tab a consultar]
     * @param {number} page [Página a cambiar para paginado]
     */
    // getRequestParams(tab, page) {
    //     let params = {};

    //     if (page) {
    //         params["page"] = page;
    //     }

    //     return params;
    // },

    /**
     * [Petición de datos API]
     * @param {number} format [Index de cabecera (Dia, Mes, Año, Personalizado)]
     */
    getCallsInfo(format) {
      this.$store.commit("layout/SET_OVERLAY", { value: true, title: "Cargando" });
      this.isLoading = true;

      const accessToken = localStorage.getItem("token");

      // let params = this.getRequestParams(
      //     // this.searchTitle,
      //     this.tab,
      //     this.currentPage
      // );
      let params = {};

      if (this.request === "custom") {
        params = { ...this.customSearchInfo };
        params["page"] = this.currentPage;
      } else {
        params["page"] = this.currentPage;
      }

      if (format === 1 || (this.CurrentRole === 10 && format === 0)) {
        this.active = true;
        this.$store.commit("layout/SET_OVERLAY", { value: false, title: "" });
      } else {
        // this.customSearchInfo = null;
        axios
          .get(`${process.env.VUE_APP_ROOTAPI}/cdr/${this.request}`, {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
            params,
          })
          .then((res) => {
            this.totalPages = res.data.data.last_page;
            this.currentPage = res.data.data.current_page;

            this.CDRInfo = res.data.data.data;
            this.webURL = res.data.url;
          })
          .catch(() => {
            // console.error(error);
            this.$snotify.error("Hubo un error en la consulta.", "Error");
          })
          .finally(() => {
            this.isLoading = false;
            this.$store.commit("layout/SET_OVERLAY", { value: false, title: "" });
          });
      }
    },

    /**
     * [Obtener estado en español]
     * @param {string} state [Estado de la llamada]
     */
    getSpanishState(state) {
      if (state == "ANSWERED") {
        return {
          text: "Contestada",
          // color: "success",
          icon: "mdi-call-received",
        };
      } else if (state == "NO ANSWER") {
        return {
          text: "No contestada",
          // color: "error",
          icon: "mdi-call-missed",
        };
      } else if (state == "BUSY") {
        return {
          text: "Ocupado",
          // color: "error",
          icon: "mdi-pause",
        };
      } else if (state == "FAILED") {
        return {
          text: "Fallido",
          // color: "error",
          icon: "mdi-alert-circle",
        };
      } else if (state == "CONGESTION") {
        return {
          text: "Congestión",
          // color: "error",
          icon: "mdi-alert-circle",
        };
      } else {
        return {
          text: state,
          // color: "error",
          icon: "mdi-alert-circle",
        };
      }
    },

    /**
     * [Obtener porcentaje de atención]
     * @param {string} value [llamadas contestadas]
     * @param {string} total [total de llamadas]
     */
    getAttentionPercentage(value, total) {
      let result = (100 * value) / total;

      return result.toFixed() + "%";
    },

    eventdialog(data, parameters) {
      this.active = false;

      if (data !== "cerrar") {
        this.isLoading = false;

        this.totalPages = data.data.last_page;
        this.currentPage = data.data.current_page;
        this.customSearchInfo = parameters;

        this.CDRInfo = data.data.data;
        this.webURL = data.url;
      } else {
        this.tab = 0;
        this.request = this.CurrentRole === 10 ? "Personalizado" : "day";
        this.customSearchInfo = null;
        this.currentPage = 1;
        this.getCallsInfo(0);
      }
    },

    descargarAudio(recordingfile, changeToMp3 = false) {
      const path = this.recordingPathGenerator(recordingfile, changeToMp3); // Generar path

      const url = `https://${this.webURL}${path}`;

      const enlace = document.createElement("a");
      enlace.href = url;
      enlace.target = "_blank"; // Abre en una nueva ventana/tab
      enlace.download = recordingfile;

      enlace.click();
    },
  },
};
</script>

<style>
.shadow-1 {
  -webkit-box-shadow: 0 8px 16px 0 rgba(40, 40, 90, 0.09), 0 3px 6px 0 rgba(0, 0, 0, 0.065);
  box-shadow: 0 8px 16px 0 rgba(40, 40, 90, 0.09), 0 3px 6px 0 rgba(0, 0, 0, 0.065);
}

audio {
  height: 35px !important;
}
</style>
